import { Component } from '@angular/core';


@Component({
	selector: 'lb-no-instructor',
	standalone: true,
	imports: [],
	templateUrl: './no-instructor.component.html',
	styleUrl: './no-instructor.component.scss'
})
export class NoInstructorComponent {}
